import "whatwg-fetch";

class Http {
  fetch(url: RequestInfo, fetchArgs: RequestInit = null, rejectHttpErrors: boolean = false): Promise<any> {
    if (!fetchArgs) {
      fetchArgs = {
        headers: new Headers({ "Content-Type": "application/json" })
      };
    }

    return new Promise((resolve, reject) => {
      fetch(url, fetchArgs)
        .then((response: Response) => {
          if (rejectHttpErrors && !response.ok) {
            throw new Error(`HTTP request failed: ${response.status}`);
          }
          return (response.headers?.get("Content-Type") || "").startsWith("application/json") ? response.json() : response;
        })
        .then((result: Response) => resolve(result))
        .catch(error => {
          reject(error);
        });
    });
  }
}

export const http = new Http();
